/*
 *
 * EasySplitPayments actions
 *
 */

import {
  DEFAULT_ACTION,
  SEARCH_PAYMENTS,
  SAVE_PAYMENTS,
  RESET_FILTERS,
  UPDATE_FILTERS,
  DISABLE_LOADER,
  ENABLE_LOADER,
  RESET_PAGE,
  UPDATE_TABLE_DATA,
  EXPORT_TO_CSV,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function searchPaymentsAction(data) {
  return {
    type: SEARCH_PAYMENTS,
    data,
  };
}

export function savePaymentsAction(data) {
  return {
    type: SAVE_PAYMENTS,
    data,
  };
}

export function resetFiltersAction() {
  return {
    type: RESET_FILTERS,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function exportToCSVAction(data) {
  return {
    type: EXPORT_TO_CSV,
    data,
  };
}
